import { render, staticRenderFns } from "./HealthFamilyInfoQuestion.vue?vue&type=template&id=c5eebdf4&scoped=true"
import script from "./HealthFamilyInfoQuestion.vue?vue&type=script&lang=js"
export * from "./HealthFamilyInfoQuestion.vue?vue&type=script&lang=js"
import style0 from "./HealthFamilyInfoQuestion.vue?vue&type=style&index=0&id=c5eebdf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5eebdf4",
  null
  
)

/* custom blocks */
import block0 from "./HealthFamilyInfoQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports